





import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import CalculatorForm from '@/components/modules/App/CalculatorComponent/CalculatorForm.vue'

interface Data {}

interface Methods {}

interface Computed {}

interface Props {}

export default Vue.extend({
  name: 'MortgageTab',
  components: {
    CalculatorForm
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
